import React, { useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./TechStack.css";

const categories = [
  {
    title: "Frontend",
    techs: ["React", "TypeScript", "JavaScript", "HTML", "CSS", "TailwindCSS"],
  },
  {
    title: "Backend",
    techs: ["Node.js", "Express", "PHP", "Python"],
  },
  {
    title: "Database",
    techs: ["MongoDB", "MySQL", "PostgreSQL"],
  },
  {
    title: "Tools",
    techs: ["Git", "Docker", "Netlify", "Vercel"],
  },
];

const TechStack = (props) => {
  useEffect(() => {
    const subscription = ScrollService.currentScreenFadeIn.subscribe(
      (screen) => {
        if (screen.fadeInScreen !== props.id) return;
        Animations.animations.fadeInScreen(props.id);
      }
    );
    return () => subscription.unsubscribe();
  }, [props.id]);

  return (
    <div className="techstack-container screen-container fade-in" id={props.id || ""}>
      <ScreenHeading title={"Tech Stack"} subHeading={"Technologies que j'utilise au quotidien"} />
      <div className="techstack-grid">
        {categories.map((cat, idx) => (
          <div key={idx} className="techstack-category">
            <h3 className="techstack-category-title">{cat.title}</h3>
            <div className="techstack-items">
              {cat.techs.map((tech, tIdx) => (
                <span key={tIdx} className="techstack-badge">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechStack;
